import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import SvgIcon from "../../../../parts/SvgIcon";
import ToolTip from "../../../../parts/tooltip";

export const SelectCommunityChatType = ({
  selectedType = [],
  onSelect,
  isEditing,
  user,
}) => {
  const { t } = useTranslation("coaching-portal");
  const { pushAccountInfo, pressAccountInfo, performSettings, pullAccountInfo } = user;

  const options = [
    pushAccountInfo?.inAppCommunityEnabled ? "push" : null,
    pressAccountInfo?.inAppCommunityEnabled ? "press" : null,
    performSettings?.inAppCommunityEnabled ? "perform" : null,
    pullAccountInfo?.inAppCommunityEnabled ? "pull" : null,
  ].filter(Boolean);

  const labels = {
    push: t("communityChat.typePush"),
    press: t("communityChat.typePress"),
    perform: t("communityChat.typePerform"),
    pull: t("communityChat.typePull"),
  };

  /**
   * Select the options
   * @param {*} item
   * @returns
   */
  const handleToggle = (item) => {
    const isSelected = selectedType.includes(item);
    const newSelection = isSelected
      ? selectedType.filter((type) => type !== item)
      : [...selectedType, item];

    onSelect(newSelection);
  };

  return (
    <>
      <div className="flex items-center gap-2 pt-5! pb-3.25">
        <span className="type-label">{t("communityChat.selectType")}</span>
        <ToolTip id="chat-type" body={t("communityChat.selectTypeTooltip")}>
          <SvgIcon
            alt={t("communityChat.infoIconAlt")}
            className="cursor-pointer"
            src="/img/new-icons/question-circle.svg"
          />
        </ToolTip>
      </div>
      <div className={isEditing ? "list pt-0!" : "list"}>
        <ul className="py-1">
          {options.map((item, index) => {
            const isSelected = selectedType.includes(item);
            return (
              <li
                key={`${item}-${index}`}
                className="flex items-center gap-2 cursor-pointer py-2 px-4"
                onClick={() => handleToggle(item)}
              >
                <SvgIcon
                  src={
                    isSelected
                      ? "/img/new-icons/checked-square.svg"
                      : "/img/new-icons/unchecked-square.svg"
                  }
                  noFilterOnLight={isSelected}
                />
                <span>{labels[item] || item.toUpperCase()}</span>
              </li>
            );
          })}
        </ul>
      </div>
    </>
  );
};

SelectCommunityChatType.propTypes = {
  selectedType: PropTypes.array,
  onSelect: PropTypes.func,
  isEditing: PropTypes.bool,
  user: PropTypes.object,
};
